// Submits the Stripe checkout the same way the legacy pug page did: a plain form POST to
// /dyn/stripe-checkout-session, which 303-redirects to Stripe. Because Stripe cannot be framed,
// the form targets `_top` so the whole window navigates out of the XM3 iframe.

export interface CheckoutFields {
  tCode: string
  tSecret: string
  // The exact license type being purchased (Pro is its own type, e.g. classroompro).
  licenseType:
    | 'classroom'
    | 'classroompro'
    | 'school'
    | 'homeschool'
    | 'homeschoolpro'
  quantity: number
  singleSeats: number
  term: 'annual' | 'sprint'
  termLength: number
  endsAt?: number
  returnTo?: string
  // Full path of the page Stripe returns to after a successful payment. Defaults, server side, to
  // the pug class report. A React page needs its real path, e.g. app/signup/teacher/welcome.
  successTo?: string
}

const CHECKOUT_URL = '/dyn/stripe-checkout-session'

export default function submitCheckout(fields: CheckoutFields): void {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = CHECKOUT_URL
  form.target = '_top'
  form.style.display = 'none'

  const values: Record<string, string> = {
    tCode: fields.tCode,
    tSecret: fields.tSecret,
    licenseType: fields.licenseType,
    quantity: String(fields.quantity),
    singleSeats: String(fields.singleSeats),
    term: fields.term,
    termLength: String(fields.termLength),
    endsAt: fields.endsAt != null ? String(fields.endsAt) : '',
    returnTo: fields.returnTo || 'teacher/upgrade_license',
    successTo: fields.successTo || '',
  }

  Object.entries(values).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
}
